import React, { useState, useEffect, useRef } from "react";
import { toJS } from "mobx";
import { useObserver } from "mobx-react";
import { useStores } from "../../store";
import { IoIosArrowDown } from "react-icons/io";

const SelectWithDropDown = (props) => {
  const { RecuiterStore } = useStores();
  const [searchTerm, setSearchTerm] = useState(props.value || "");
  const [selectedItem, setSelectedItem] = useState(null);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);

  const items = props.options || [
    { value: "Angular", label: "Angular" },
    { value: "C", label: "C" },
    { value: "CIVIL", label: "CIVIL" },
    { value: "CSE", label: "CSE" },
    { value: "Cloud", label: "Cloud" },
    { value: "Data Science", label: "Data Science" },
    { value: "Deep Learning", label: "Deep Learning" },
    { value: "DevOps", label: "DevOps" },
    { value: "ECE", label: "ECE" },
  ];

  const filteredItems = items.filter((item) =>
    item?.label?.toLowerCase().includes((searchTerm || "").toLowerCase())
  );

  const handleSelect = (item) => {
    setSelectedItem(item);
    setSearchTerm(item.label);
    setDropdownVisible(false);
    if (props.action) {
      props.action({ target: { value: item.label } });
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Update searchTerm and selectedItem when props.value changes
  useEffect(() => {
    if (props.value !== undefined && props.value !== null) {
      setSearchTerm(props.value);
      // Find and set the selected item if it exists in options
      const optionsToSearch = props.options || [
        { value: "Angular", label: "Angular" },
        { value: "C", label: "C" },
        { value: "CIVIL", label: "CIVIL" },
        { value: "CSE", label: "CSE" },
        { value: "Cloud", label: "Cloud" },
        { value: "Data Science", label: "Data Science" },
        { value: "Deep Learning", label: "Deep Learning" },
        { value: "DevOps", label: "DevOps" },
        { value: "ECE", label: "ECE" },
      ];
      const matchingItem = optionsToSearch.find(
        (item) => item.label === props.value || item.value === props.value
      );
      if (matchingItem) {
        setSelectedItem(matchingItem);
      } else {
        // Clear selectedItem if no match found
        setSelectedItem(null);
      }
    } else {
      setSearchTerm("");
      setSelectedItem(null);
    }
  }, [props.value, props.options]);

  return useObserver(() => (
    <div
      className={`flex relative flex-col gap-y-2 text-lg ${
        props.isLanguage ? "w-full mt-2" : ""
      } mx-auto`}
      ref={dropdownRef}
    >
      <label
        className={`font-sans text-base ${props.isLanguage ? "" : "ml-3"} ${
          props.isLanguage ? "text-black" : "text-[#6D6B6B]"
        }`}
        onDoubleClick={props.onDoubleClick}
        onClick={() => {
          console.log(toJS(RecuiterStore.jobPostDetails));
          console.log(toJS(props));
        }}
      >
        {props.label}
      </label>
      <div className="relative">
        <div
          className={`absolute inset-y-0 right-3 flex items-center ${
            props.isMcqTestOn ? "" : "pl-3"
          } ${props.isLanguage ? "" : "pl-3"}`}
        >
          <IoIosArrowDown className="h-4 w-4 text-[#242424]" />
        </div>
        <input
          type="text"
          placeholder={props.placeholder || "Search by name"}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => setDropdownVisible(true)}
          className={`border  ${
            props.isLanguage && props.isMcqTestOn ? "px-5" : "px-4 pr-10"
          } ${props.isMcqTestOn ? "h-16" : ""} text-base ${
            props.isLanguage
              ? "border-primary outline-none w-[90%] rounded-xl"
              : "border-[#c9c9c9] min-w-[150px] w-full rounded-lg"
          } ${props.height || "h-10"} ${
            props.value === ""
              ? `${
                  props.isLanguage && props.isMcqTestOn
                    ? "text-primary"
                    : "text-gray-500"
                }`
              : `${
                  props.isLanguage && props.isMcqTestOn
                    ? "text-primary"
                    : "text-black"
                }`
          }`}
          required={props.required}
          onInvalid={(e) => {
            if (props.hideError) {
              e.preventDefault(); // Suppress the default error message
              e.target.focus(); // Focus the input field
              props.onError();
            }
          }}
        />
      </div>
      {isDropdownVisible && (
        <ul className=" bg-white  border absolute w-full top-20 z-10 border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
          {filteredItems.map((item, index) => (
            <li
              key={index}
              className={`px-4 py-2 hover:${
                props.isLanguage ? "border-primary" : "bg-gray-100"
              } cursor-pointer ${
                selectedItem?.value === item.value ? "bg-secondary" : ""
              }`}
              onClick={() => handleSelect(item)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  ));
};

export default SelectWithDropDown;
